import { BadImplementationException, exists } from '@nu-art/ts-common';
import { valueType_Enumerated, valueType_Range, valueType_SubEnumerated, valueType_SubRange } from './consts.js';
import { TimespansType, TimespanType_Second } from '../../_enum/index.js';
import { TimespanLabelsMap, TimespanToValue } from '../../_enum/index.js';
/**
 * Infer the multiplier type for a timestamp passed to the function
 * @param value a timestamp representing time period
 */
export const inferMultiplier = (value) => {
    if (!value)
        return TimespanType_Second;
    return [...TimespansType].reverse().find(timespan => Number.isInteger(value / TimespanToValue[timespan])) ?? TimespanType_Second;
};
export const getCleanPreDBValue = (type, parentValue) => {
    const value = { type };
    switch (type) {
        case valueType_Enumerated: {
            value.data = {
                subsets: [],
                scope: [],
                props: {},
            };
            break;
        }
        case valueType_Range: {
            value.data = {
                subsets: [],
                scope: [0, 0],
            };
            break;
        }
        case valueType_SubEnumerated: {
            value.data = {
                scope: [],
                parentId: parentValue?._id
            };
            break;
        }
        case valueType_SubRange: {
            let scope = [0, 0];
            if (parentValue && parentValue.type === valueType_Range)
                scope = parentValue.data.scope;
            value.data = {
                parentId: parentValue?._id,
                scope,
            };
            break;
        }
        default:
            throw new BadImplementationException(`Missing implementation for type: ${type}`);
    }
    return value;
};
export function addIndexingFields(instance) {
    const __valueIds = [];
    let __unitsId = undefined;
    const __variableIds = [];
    switch (instance.type) {
        case 'enumerated':
            __valueIds.push(...instance.data.scope);
            __valueIds.push(...instance.data.subsets);
            break;
        case 'range':
            __unitsId = instance.data.unitsId;
            __valueIds.push(...instance.data.subsets);
            break;
        // case 'sub-range': break;
        case 'sub-enumerated':
            __valueIds.push(...instance.data.scope);
            break;
        // case 'enum-element': break;
        case 'tuple':
            __valueIds.push(...instance.data.scope);
            break;
        case 'standard-range':
            __unitsId = instance.data.unitsId;
            __variableIds.push(...instance.data.declarationVarIds);
            break;
    }
    if (!__unitsId)
        delete instance.__unitsId;
    else
        instance.__unitsId = __unitsId;
    instance.__valueIds = __valueIds;
    instance.__variableIds = __variableIds;
}
/**
 * Resolve UI display for a time range value and format it as human-readable value
 * @param value UI value for resolving
 */
export const resolveTimeRangeDisplay = (value) => {
    if (!value.data)
        throw new BadImplementationException('cannot resolve display name of a value without range data');
    // Create reusable variable of values
    const firstTimeRangeElement = value.data.timeRange[0];
    const secondTimeRangeElement = value.data.timeRange[1];
    // Infer values multiplier
    const firstValueMultiplier = inferMultiplier(firstTimeRangeElement);
    const secondValueMultiplier = inferMultiplier(secondTimeRangeElement);
    // resolve the label in case to values exists
    if (exists(firstTimeRangeElement) && exists(secondTimeRangeElement)) {
        return `${firstTimeRangeElement / TimespanToValue[firstValueMultiplier]} ${TimespanLabelsMap[firstValueMultiplier]} - ${secondTimeRangeElement / TimespanToValue[secondValueMultiplier]} ${TimespanLabelsMap[secondValueMultiplier]}`;
    }
    // resolve the label if only the first one exists
    if (exists(firstTimeRangeElement)) {
        return `≥ ${firstTimeRangeElement / TimespanToValue[firstValueMultiplier]} ${TimespanLabelsMap[firstValueMultiplier]}`;
    }
    // resolve the value if only the second value exists
    if (exists(secondTimeRangeElement)) {
        return `≤ ${secondTimeRangeElement / TimespanToValue[secondValueMultiplier]} ${TimespanLabelsMap[secondValueMultiplier]}`;
    }
    // this means we try to print invalid value, which cannot be done
    throw new BadImplementationException('invalid value to print');
};
//# sourceMappingURL=utility.js.map